export {default} from './SubTitle';